fragment RoutinePreviewFragment on EntryInterface {
  id
  slug
  uri
  title
  ... on routine_Entry {
    image {
      url
      title
    }
    duration
    teaserText
    description
    instructions
    sports {
      title
    }
    painPoints {
      title
    }
    trainingGoals {
      title
    }
    difficulty {
      title
    }
    exerciseCount
  }
  ... on workout_Entry {
    image {
      url
      title
    }
    duration
    teaserText
    description
    instructions
    sports {
      title
    }
    painPoints {
      title
    }
    trainingGoals {
      title
    }
    difficulty {
      title
    }
    exerciseCount
  }
  ... on workoutCollection_Entry {
    image {
      url
      title
    }
    duration
    teaserText
    description
    instructions
    sports {
      title
    }
    painPoints {
      title
    }
    trainingGoals {
      title
    }
    difficulty {
      title
    }
    exerciseCount
  }
}
